const KeenSlider = window.KeenSlider

const { useAutoplay } = window.BAO.Carousel.plugins

class AnnouncementBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setHeight = this.setHeight.bind(this)

    window.addEventListener('resize', this.setHeight)
    this.setHeight()

    this.setAttribute('loaded', '')

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()

    this.handleKeydown = this.handleKeydown.bind(this)
    this.addEventListener('keydown', this.handleKeydown)
  }

  handleKeydown (event) {
    if (event.key === 'ArrowLeft') {
      event.preventDefault()
      this.carousel.prev()
    } else if (event.key === 'ArrowRight') {
      event.preventDefault()
      this.carousel.next()
    } else if (event.key === 'Enter' || event.key === ' ') {
      const currentSlide = this.els.slide.elements[
        this.carousel.track.details.rel
      ]
      const link =
        currentSlide && currentSlide.querySelector('.util-FauxLink_Link')

      if (link) {
        event.preventDefault()
        link.click()
      }
    }
  }

  setHeight () {
    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.els.body.element.offsetHeight}px`,
    )
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [useAutoplay(4, { pauseOnHover: true, pauseOnFocus: true })],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
